var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loginbg", attrs: { id: "login-main-hr" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-9 col-md-7 col-lg-5 mx-auto" }, [
          _c("div", { staticClass: "loginform" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "form",
              [
                !_vm.ssoLogin || _vm.isNonVVGDealer != "NO"
                  ? [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "username" } }, [
                          _vm._v("Username / Dayforce Id")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.username,
                              expression: "username"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "text",
                            name: "username",
                            id: "username_login",
                            placeholder: "Enter Username / Dayforce Id"
                          },
                          domProps: { value: _vm.username },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.username = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "help is-danger" }, [
                          _vm._v(_vm._s(_vm.username_error_msg))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "password" } }, [
                          _vm._v("Password")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { position: "relative" } },
                          [
                            _vm.isPasswordHide
                              ? [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.password,
                                        expression: "password"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "password",
                                      name: "password",
                                      id: "password_login",
                                      placeholder: "Enter password"
                                    },
                                    domProps: { value: _vm.password },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.password = $event.target.value
                                      }
                                    }
                                  })
                                ]
                              : [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.password,
                                        expression: "password"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      name: "password",
                                      id: "password_login",
                                      placeholder: "Enter password"
                                    },
                                    domProps: { value: _vm.password },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.password = $event.target.value
                                      }
                                    }
                                  })
                                ],
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.hideShowPassword()
                                  }
                                }
                              },
                              [
                                _vm.isPasswordHide
                                  ? [
                                      _c("i", {
                                        staticClass: "fa fa-eye",
                                        staticStyle: {
                                          position: "absolute",
                                          top: "10px",
                                          right: "12px"
                                        }
                                      })
                                    ]
                                  : [
                                      _c("i", {
                                        staticClass: "fa fa-eye-slash",
                                        staticStyle: {
                                          position: "absolute",
                                          top: "10px",
                                          right: "12px"
                                        }
                                      })
                                    ]
                              ],
                              2
                            )
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "help is-danger" }, [
                          _vm._v(_vm._s(_vm.password_error_msg))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "help is-danger" }, [
                        _vm._v(_vm._s(_vm.error_msg_login))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                disabled: _vm.disableButtons.loginButton,
                                id: "loginbtn",
                                type: "submit"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.login(this)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.buttonNames.loginButton))]
                          ),
                          _vm._v(" "),
                          _vm.isNonVVGDealer == "NO"
                            ? [
                                _c(
                                  "a",
                                  {
                                    staticStyle: { float: "right" },
                                    attrs: {
                                      href: _vm.forgot_pass_url,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._v("Forgot password?")]
                                )
                              ]
                            : [
                                _c(
                                  "router-link",
                                  {
                                    staticStyle: { float: "right" },
                                    attrs: {
                                      to: { name: "UserForgotPassword" }
                                    }
                                  },
                                  [_vm._v(" Forgot password?")]
                                )
                              ]
                        ],
                        2
                      )
                    ]
                  : [
                      _c(
                        "label",
                        {
                          staticClass:
                            "checkbox-inline checkbox-bootstrap checkbox-lg"
                        },
                        [
                          _vm._v(
                            "\n                                Logout from ("
                          ),
                          _c("a", { attrs: { href: _vm.ssoUrl } }, [
                            _vm._v(_vm._s(_vm.ssoUrl))
                          ]),
                          _vm._v(
                            "),If You are not able to login please clear Cookies and login again.\n                                Please contact admin if you are still not able to Login.\n                            "
                          )
                        ]
                      )
                    ]
              ],
              2
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loginlogo" }, [
      _c("img", {
        attrs: {
          src: "static/images/login-logo.png",
          alt: "Velocity Vehicle Group"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-657094ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657094ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = null
// module chunks = 